export default __webpack_public_path__ + "static/media/learnSmarterNotHarder3.5217617c.gif";